import React from 'react'
import cx from 'classnames'
import config from 'app-config'
import { connect } from 'redaction'

import Link from 'components/ui/Link/Link'

import s from './LayerLink.scss'


const LayerLink = ({ domain, id, link, title, isActive, toOLD, onClick }) => (
  <Link
    className={cx(s.link, { [s.active]: isActive })}
    to={toOLD ? null : link}
    toOLD={toOLD ? link : null}
    onClick={onClick}
  >
      <span className={s.imageContainer}>
        <img className={s.default} src={`${domain}/img/upside_menu/upside_menu_ico${id}_2018.svg`} />
        <img className={s.hover} src={`${domain}/img/upside_menu/upside_menu_ico${id}_hover_2018.svg`} />
      </span>
    <span className={s.title}>{title}</span>
  </Link>
)


export default connect({
  domain: () => {
    if (config.api === 'test') {
      return 'https://smartsarov.ru'
    }

    return ''
  },
})(LayerLink)
